(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FLAKE =
    '<svg viewBox="0 0 112.28 112.28" fill="none" stroke="currentColor" stroke-width="7"><path d="M56.14 0V112.28M0 56.14H112.28M16.44 16.44L95.84 95.84M95.84 16.44L16.44 95.84M43.34 4.92L56.14 17.73L68.94 4.92M43.34 107.36L56.14 94.56L68.94 107.36M4.92 43.34L17.73 56.14L4.92 68.94M107.36 43.34L94.56 56.14L107.36 68.94"/></svg>';

  function burst(x, y, { count = 16, color = '#d0e4ff', spread = 140 } = {}) {
    if (reduceMotion) return;
    const layer = document.createElement('div');
    layer.className = 'mda-burst';
    layer.style.cssText = `position:fixed;left:${x}px;top:${y}px;width:0;height:0;pointer-events:none;z-index:1000;color:${color}`;
    document.body.appendChild(layer);
    let left = count;
    for (let i = 0; i < count; i++) {
      const flake = document.createElement('span');
      const size = 10 + Math.random() * 16;
      flake.innerHTML = FLAKE;
      flake.style.cssText = `position:absolute;left:${-size / 2}px;top:${-size / 2}px;width:${size}px;height:${size}px;display:block`;
      layer.appendChild(flake);
      const angle = (Math.PI * 2 * i) / count + Math.random() * 0.5;
      const dist = spread * (0.5 + Math.random() * 0.6);
      const dx = Math.cos(angle) * dist;
      const dy = Math.sin(angle) * dist;
      flake
        .animate(
          [
            { transform: 'translate(0,0) rotate(0deg) scale(0.4)', opacity: 1 },
            { transform: `translate(${dx}px,${dy}px) rotate(${120 + Math.random() * 120}deg) scale(1)`, opacity: 0.9, offset: 0.55 },
            { transform: `translate(${dx * 1.1}px,${dy + 60}px) rotate(260deg) scale(0.8)`, opacity: 0 },
          ],
          { duration: 1100 + Math.random() * 500, easing: 'cubic-bezier(0.2,0.7,0.3,1)', fill: 'forwards' }
        )
        .finished.then(() => {
          if (--left === 0) layer.remove();
        });
    }
  }
  window.mdaSnowBurst = burst;

  // Tap a snowy panel to shake the snow globe.
  if (window.mdaHolidayFx?.shake) {
    document.querySelectorAll('.mda-snowfall').forEach((s) => s.parentElement.setAttribute('data-mda-shake', ''));
  }
  document.addEventListener('click', (e) => {
    const panel = e.target.closest('[data-mda-shake]');
    if (!panel || e.target.closest('a, button, input, select, textarea, label')) return;
    burst(e.clientX, e.clientY, { count: 22, color: getComputedStyle(panel).getPropertyValue('--mda-shake-color') || '#d0e4ff' });
  });

  // Spend progress bars.
  const fmt = (cents, format) => {
    const whole = cents % 100 === 0;
    const amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amount);
  };

  function paint(meter, cart, celebrate) {
    const total = meter.dataset.basis === 'before' ? cart.original_total_price : cart.total_price;
    const amounts = meter.dataset.amounts.split(',').map((a) => Number(a) * 100);
    const labels = meter.dataset.labels.split('|');
    const top = amounts[amounts.length - 1];
    meter.querySelector('[data-mda-gm-fill]').style.width = `${Math.min(100, (total / top) * 100)}%`;
    const marks = meter.querySelectorAll('[data-mda-gm-mark]');
    const tiers = meter.querySelectorAll('[data-mda-gm-tier]');
    amounts.forEach((a, i) => {
      const reached = total >= a;
      const mark = marks[i];
      if (reached && !mark.classList.contains('is-reached') && celebrate) {
        mark.classList.add('is-new');
        const r = mark.getBoundingClientRect();
        burst(r.left + r.width / 2, r.top + r.height / 2, { count: 14, color: '#6f96d1', spread: 90 });
        setTimeout(() => mark.classList.remove('is-new'), 700);
      }
      mark.classList.toggle('is-reached', reached);
      tiers[i]?.classList.toggle('is-reached', reached);
    });
    const next = amounts.findIndex((a) => total < a);
    meter.querySelector('[data-mda-gm-msg]').textContent =
      next === -1
        ? meter.dataset.msgDone
        : meter.dataset.msgNext.replace('[amount]', fmt(amounts[next] - total, meter.dataset.moneyFormat)).replace('[gift]', labels[next]);
  }

  async function refresh(celebrate = true) {
    const meters = document.querySelectorAll('[data-mda-gift-meter]');
    if (!meters.length) return;
    try {
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { accept: 'application/json' } })).json();
      meters.forEach((m) => paint(m, cart, celebrate));
    } catch (e) {}
  }

  // Refresh after any cart change, whoever makes it: theme forms, the cart app, or Shopify's own scripts.
  let timer;
  const queue = (celebrate = true) => { clearTimeout(timer); timer = setTimeout(() => refresh(celebrate), 350); };
  const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const isCartWrite = (url) => { try { return CART_WRITE.test(new URL(url, location.href).pathname); } catch (e) { return false; } };
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url;
    const result = origFetch.apply(this, arguments);
    if (url && isCartWrite(url)) result.then(() => queue(), () => {});
    return result;
  };
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) this.addEventListener('loadend', () => queue());
    return origOpen.apply(this, arguments);
  };
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => queue());
  document.addEventListener('visibilitychange', () => { if (!document.hidden) queue(false); });
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(false); });
})();
